<template>
  <Transition name="fade">
    <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <h2>{{ $t("message.Withdrawalunlock") }}</h2>
        <p class="text">
          {{ $t("message.WithdrawalunlockTip", { num: addCommasToNumber(now || 0) }) }}
        </p>
        <button @click="closeModal" class="close-button">
          {{ $t("message.Close") }}
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref } from "vue";
import emitter from "../utils/bus";
import { addCommasToNumber } from "../utils/common";

const isVisible = ref(false);
const now = ref(0);

const closeModal = () => {
  isVisible.value = false;
};

emitter.on("WithdrawalModal", (data) => {
  isVisible.value = true;
  now.value = data?.now || 0;
});
</script>

<style scoped lang="scss">
@use "@/styles/surfaces" as surface;

.modal-overlay {
  @include surface.dialog-overlay;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  @include surface.dialog-panel;
  background-color: #1a1a1a;
  text-align: center;
  color: #ffffff;
}

.text {
  font-size: 14px;
  line-height: 1.6;
  margin: 8px 0;
  color: #cccccc;
}

h2 {
  @include surface.title;
  margin-top: 0;
  font-weight: bold;
  color: #ffffff;
}

.friends-count {
  font-size: 14px;
  margin: 8px 0;
  color: var(--themes-color);
}

.invite-button {
  @include surface.button;
  width: 100%;
  background-color: var(--themes-color);
  color: white;
  border: none;
  cursor: pointer;
}

.close-button {
  @include surface.button;
  margin-top: 6px;
  width: 100%;
  background-color: #333333;
  border: none;
  cursor: pointer;
  color: #cccccc;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
